export function getMergedStorageFiles({ acceptedFiles, prevFiles, requestId }) {
  const prevFilesById = new Map(prevFiles.map(file => [file.id, file]))

  // The attach modal resubmits the full selection — keep previously attached
  // objects so their request markers survive.
  return acceptedFiles.map(
    file =>
      prevFilesById.get(file.id) || (requestId ? { ...file, requestId } : file)
  )
}
